import styles from "./Products.module.less";
import React, { useState, useEffect, useRef} from "react";
import { useCartStore, useCorpInfoStore } from '@/stores'
import { utils, apis } from '@/utils';
import ProductCell from "../ProductCell/ProductCell";
import Masonry from 'react-masonry-css'
import type { RequestParams } from '@/types/product'
import { InfiniteScroll, Toast } from 'antd-mobile'
import { useUpdateEffect } from "ahooks";
import { t } from "@/utils/i18n";
// 导入图片
import iconNoData from '@/assets/img/default/empty_list.jpg'

const { to, px2rem } = utils;
const { productApi } = apis;

interface ModuleProps {
  requestParams: RequestParams
}

let pageNum = 1

const Products: React.FC<ModuleProps> = (props) => {
  const { requestParams } = props;
  const { corpInfo } = useCorpInfoStore()
  const { cart } = useCartStore()
  const { corpId, customerId } = corpInfo
  const { cartId } = cart
  const [products, setProducts] = useState([]);
  const [cellWidth, setCellWidth] = useState('');
  const refMasonry = useRef<HTMLDivElement | null>(null);
  const [hasMore, setHasMore] = useState(false)
  const [noData, setNoData] = useState(false)
  const [loading, setLoading] = useState(true)

  const breakpointColumnsObj = {
    default: 2,
  }

  async function loadMore() {
    pageNum = pageNum + 1
    return getProductList(pageNum)
  }

  useUpdateEffect(() => {
    (async () => {
      pageNum = 1
      setHasMore(false)
      setProducts([])
      setNoData(false)
      await getProductList(pageNum)
    })()
  }, [requestParams])

  /*
    * 请求列表数据
    */
  async function getProductList(pageNum = 1) {
    setLoading(true)

    const [error, res] = await to(
      productApi.prodList({
        corpId,
        cartId,
        pageSize: 20,
        ...requestParams,
        customerId,
        pageNum,
      })
    )

    setLoading(false)
    const { data: list, pages, code } = res
    if (error) {
      Toast.show({ content: error.msg })
      return
    }

    if (pageNum === 1) {
      setProducts(list || [])
    } else {
      setProducts(products.concat(...(list || [])))
    }

    if (
      (Array.isArray(list) && pageNum >= pages) ||
      error ||
      (code === 0 && !list)
    ) {
      setHasMore(false)
    } else {
      setHasMore(true)
    }

    if (pageNum === 1 && list.length === 0) {
      setNoData(true)
    }
  }

  useEffect(() => {
    if (refMasonry.current) {
      const offset = window.getComputedStyle(refMasonry.current)

      setCellWidth(`calc(${window.screen.width / 2}px - ${offset.paddingLeft} - ${px2rem(8)})`)
    }
  }, [])

  return (
    <div className={styles['product-wrap']}>
      <div className={styles['product-bd']} ref={refMasonry}>
        <Masonry
          breakpointCols={breakpointColumnsObj}
          className={styles['my-masonry-grid']}
          columnClassName={styles['my-masonry-grid_column']}
        >
          {products.map((item, index) => (
            <ProductCell item={item} index={index} key={index} cellWidth={cellWidth} />
          ))}
        </Masonry>

        {(loading && pageNum === 1) && (
          <div
            className="product-list-skeleton"
            style={{ height: '100vh', backgroundColor: 'white' }}
          ></div>
        )}

        {hasMore && <InfiniteScroll loadMore={loadMore} hasMore={hasMore} />}
        {(!loading && noData) && (
          <div className={styles['no-result']}>
            <img src={iconNoData} />
            <p>{t('暂无货品')}</p>
          </div>
        )}
        {(!loading && !noData && !hasMore) && (
          <p className={styles['more-msg']}>{t('--- 已经到底啦 ---')}</p>
        )}
      </div>
    </div>
  );
}

export default Products